/** The element `AppHtml` writes its `data` into, as JSON that never runs (so a Content-Security-Policy needs no inline script). */
export const APP_DATA_ELEMENT_ID = "app-data";

/** The element `Html` writes its page props into, the same way. */
export const PAGE_PROPS_ELEMENT_ID = "page-props";

const readJsonElement = (id: string): unknown => {
  const text = typeof document === "undefined" ? null : document.getElementById(id)?.textContent;
  if (!text) {
    return undefined;
  }
  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
};

// An older shell (or an app's own) assigned the data to a window global in an inline script; still read, for such a page.
const legacyGlobal = (name: "__APP_DATA__" | "__PAGE_PROPS__"): unknown =>
  typeof window === "undefined" ? undefined : (window as unknown as Record<string, unknown>)[name];

/** The `data` the page's `AppHtml` was rendered with, or undefined (a shell without data). The caller knows its shape. */
export const readAppData = <T>(): T | undefined => (readJsonElement(APP_DATA_ELEMENT_ID) ?? legacyGlobal("__APP_DATA__")) as T | undefined;

/** The page props the page's `Html` was rendered with; `{}` when there are none. */
export const readPageProps = (): Record<string, unknown> =>
  (readJsonElement(PAGE_PROPS_ELEMENT_ID) ?? legacyGlobal("__PAGE_PROPS__") ?? {}) as Record<string, unknown>;
